import React from "react";

function NewsCard({ article }) {
  const { title, description, image, date, source, NewsSource, link } = article;

  return (
    <div className="card">
      {image && <img src={image} alt="" />}

      <div className="content">
        <span style={{ fontSize: "13px", fontWeight: 600, color: "#0066cc" }}>
          {" "}
          {source || "Unknown"}
        </span>
        <div className="title">{title}</div>
        <div className="desc">{description || ""}</div>

        <a href={NewsSource || link} target="_blank" rel="noopener noreferrer">
          Read more
        </a>

        {/* <div>
          <b>Source:</b> {source || "Unknown"}
        </div> */}
      </div>
    </div>
  );
}

export default NewsCard;
